module.exports = __webpack_public_path__ + "anchor-2a6946594fc0f0b4bacf57f6ee93dd18.png";